<form
  class="needs-validation p-3"
  [formGroup]="passwordForm"
  (submit)="handleSubmit($event)"
>
  <div
    class="alert alert-primary"
    role="alert"
    i18n="AuthPage|Reset password info message@@resetPasswordPageInfoMessage"
  >
    <fa-icon [icon]="['fas', 'circle-info']" class="mr-1"></fa-icon> The
    password must be at least 12 characters long and must contain at least one
    uppercase letter, one lowercase letter, one numerical digit, and one special
    character.
  </div>
  @for (field of formFieldsArr; track field) {
  <div class="input-wrapper mb-3">
    <input
      type="password"
      class="form-control"
      [placeholder]="field.placeholder"
      [formControlName]="field.control"
      [attr.data-e2e]="field.e2e"
      [ngClass]="getValidityClass(field.control)"
      [attr.autocomplete]="field.autocomplete"
    />
    @if (getInputErrorMessages(field.control).length > 0) { @for (error of
    getInputErrorMessages(field.control); track error) {
    <span class="invalid-feedback">{{ error }}</span>
    } }
  </div>
  } @if ((changingPassword$ | async) === false) {
  <button
    type="submit"
    class="btn btn-block btn-primary mb-2"
    data-e2e="submit-change-password"
    i18n="UserMenu@@userMenuChangePasswordSubmitButton"
    [disabled]="!passwordForm.valid"
  >
    Submit
  </button>
  } @else {
  <div class="d-flex justify-content-center align-items-center">
    <fa-icon [icon]="['fas', 'spinner']" [spin]="true" [pulse]="true"></fa-icon>
  </div>
  } @if (changePasswordErrors$ | async; as errorMessages) {
  <ul class="px-3 text-danger">
    @for (errorMessage of errorMessages; track errorMessage) {
    <li class="remote-error-message">
      <span>
        {{ errorMessage | translatePasswordValidations }}
      </span>
    </li>
    }
  </ul>
  }
</form>
